import useEventListener from "@myvp/shared/src/hooks/use-event-listener"
import React from "react"
import { useNavigate, useSearchParams } from "react-router"
import { popSearchParam } from "@myvp/shared/src/functions/pop-search-param"
import { Destination } from "src/pages/sponsors-redirect"
import * as authModel from "src/auth/auth.model"
import { libraryManagerRouteNames } from "src/pages/library-manager/library-manager.route-names"
import { useMutation } from "@tanstack/react-query"

const NavigateToCustomerLibrary = () => {
  const navigate = useNavigate()
  const [s] = useSearchParams()
  let searchParams = new URLSearchParams(s)

  const vaultdns = popSearchParam(searchParams, "vaultdns")
  const vaultId = popSearchParam(searchParams, "vaultId")
  const destination = popSearchParam(searchParams, "destination") as Destination

  if (!vaultdns || !vaultId) {
    throw new Error("fallback")
  }

  const embeddedLogin = useMutation({
    mutationFn: (args: {
      destination: Destination
      vaultDns: string
      vaultId: string
      sessionToken: string
    }) => authModel.embeddedLogin(args),
    onSuccess: (_, { vaultId }) => {
      navigate(
        {
          pathname: libraryManagerRouteNames.embeddedLibrary({ vaultId }),
          search: searchParams.toString(),
        },
        { replace: true }
      )
    },
    throwOnError: true,
  })

  React.useEffect(() => {
    const readyMessage = JSON.stringify({ message_id: "ready", data: {} })
    window.parent?.postMessage(readyMessage, "*")
  }, [vaultdns])

  useEventListener("message", (event: MessageEvent) => {
    let message
    try {
      message = JSON.parse(event.data)
    } catch {}

    if (
      !!message &&
      message.message_id === "session_id" &&
      !!vaultId &&
      !!vaultdns
    ) {
      embeddedLogin.mutate({
        destination,
        vaultDns: vaultdns,
        vaultId,
        sessionToken: message.data.session_id,
      })
    }
  })

  return <></>
}

export default NavigateToCustomerLibrary
